import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '../App';
import '../styles/globals.css';
import '../utils/logger'; // ✅ Initialize logger (registers window.toggleDebug)

// Service Worker is automatically registered by App.tsx
// PWA Manifest is served from /public/manifest.json (in production)

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Remove FOUC protection after initial render
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    document.getElementById('root')?.classList.add('loaded');
  });
});
